import {store} from '@risingstack/react-easy-state';

const UtilsStore = store({allowScroll: true});

export default UtilsStore;